import React from 'react';
import '../ServiceNewsletter.scss';
import { useTranslation } from 'react-i18next';
import Modal from 'components/modal/Modal';
import ModulesMobileCardLevel4 from 'pages/CatalogVehicle/TechnicalDocumentation/ModulesMobileCardLevel4/ModulesMobileCardLevel4';
import IframeModalMobileCardLevel4 from 'pages/CatalogVehicle/TechnicalDocumentation/ModulesMobileCardLevel4/IframeModal/IframeModalMobileCardLevel4';

type Props = {
  data
  onMainGroupClick?: (item) => void;
  onSubGroupClick?: (item) => void;
  onItemMpClick?: (item) => void;
  onItemMpManualClick?: (item) => void;
  activeItem?: number | string;
  setOpenModal?: (value: boolean) => void
  showModal: boolean;
  loadingHTML: boolean;
  iframeData?: string;
}

const ServiceNewsletterMobileView: React.FC<Props> = (props) => {

  const { t } = useTranslation();

  return (
      <div className="tdoc-module">
        <ModulesMobileCardLevel4
          title={t('_service_newsletter')}
          data={props.data}
          onMainGroupClick={props.onMainGroupClick}
          onSubGroupClick={props.onSubGroupClick}
          onItemMpClick={props.onItemMpClick}
          onItemMpManualClick={props.onItemMpManualClick}
          activeItem={props.activeItem}
          setOpenModal={props.setOpenModal}
        />
        <Modal
          openModal={props.showModal}
          setOpenModal={props.setOpenModal}
          childrenComponent={
            <IframeModalMobileCardLevel4
              title={t('_service_newsletter')}
              loading={props.loadingHTML}
              setOpenModal={props.setOpenModal}
              vehicleIframe={props.iframeData!}
            />
          }
        />
      </div>
  );
};

ServiceNewsletterMobileView.displayName = 'ServiceNewsletterMobileView';

export default ServiceNewsletterMobileView;